/** Ski promotion window: 10 Dec – end of February (inclusive). */
export function isSkiPeriod(date: Date = new Date()): boolean {
  const m = date.getMonth(); // 0 = Jan
  const d = date.getDate();
  if (m === 11) return d >= 10;
  return m === 0 || m === 1;
}
